import Helper from "./Helper";
import Swiper from "swiper/bundle";

class HeaderImageAnimation {
  constructor(config = {}) {
    const {
      selector,
    } = config;
    this.selector = selector;
    this.containers = document.querySelectorAll(this.selector);

    this.bindEvents();
  }

  bindEvents() {
    this.containers.forEach((container, index) => {
      const orderedKeywords = [...container.querySelectorAll('.ns-header-animation__keyword')];
      let keywords = [];
      let lastKeywordLength = 0;

      while (orderedKeywords.length > 1) {
        let randomInt = Math.floor(Math.random() * orderedKeywords.length);
        let newWord = orderedKeywords[randomInt];

        if (newWord.innerText.length > lastKeywordLength + 3 || lastKeywordLength > 5) {
          keywords.push(newWord);
          lastKeywordLength = newWord.innerText.length;
          orderedKeywords.splice(randomInt, 1);
        }
      }

      // in case the last 2 keywords are short
      if (orderedKeywords[0].innerText.length >= lastKeywordLength + 3) {
        keywords.splice(1, 0, orderedKeywords[0]);
      } else {
        keywords.push(orderedKeywords[0]);
      }

      // let keywords = [...container.querySelectorAll('.ns-header-animation__keyword')];

      // for (let i = 0; i < Math.floor(Math.random() * 30); i++)
      //   keywords = keywords.sort(() => (Math.random() > .5) ? 1 : -1);

      let keywordContainer = document.querySelector('.ns-header-animation__keyword-wrapper');
      let prevItem = null;
      let itemIndex = 0;

      // console.log(keywordContainer.clientWidth)
      // console.log(keywordContainer.clientHeight)

      keywords.forEach(buzz => {
        buzz.setAttribute('data-after-content', buzz.innerText);
      })



      this.removeAnimation(prevItem);
      prevItem = keywords[itemIndex];
      this.giveAnimation(prevItem, keywordContainer);
      itemIndex++;

      window.setInterval(() => {

        this.removeAnimation(prevItem);
        prevItem = keywords[itemIndex];
        this.giveAnimation(prevItem, keywordContainer);
        itemIndex++;

        if (itemIndex >= keywords.length)
          itemIndex = 0;

      }, 3000);
    });

  }

  giveAnimation(item, keywordContainer) {
    if (item) {
      item.style.left = Math.floor(Math.random() * (keywordContainer.clientWidth - item.clientWidth)) + 'px';
      item.style.top = Math.floor(Math.random() * (keywordContainer.clientHeight - item.clientHeight)) + 'px';

      item.classList.add('animate');
    }
  }

  removeAnimation(item) {
    if (item)
      window.setTimeout(() => {
        item.classList.remove('animate');
      }, 1000)
  }

}

export default HeaderImageAnimation;
